module.exports = __webpack_public_path__ + "img/galerie-44.34b66249.jpg";